import script from "./resmanage.vue?vue&type=script&setup=true&lang=js"
export * from "./resmanage.vue?vue&type=script&setup=true&lang=js"

import "./resmanage.vue?vue&type=style&index=0&id=5490df5d&lang=scss"

const __exports__ = script;

export default __exports__